import React, { useState } from 'react'; 
import 'bootstrap/dist/css/bootstrap.min.css';

const TextConverter = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const handleInput = (e) => {
    setInput(e.target.value);
    setOutput(e.target.value);
  };

  const handleConvert = (type) => {
    switch (type) {
      case 'sentence':
        setOutput(input.charAt(0).toUpperCase() + input.slice(1).toLowerCase());
        break;
      case 'lower':
        setOutput(input.toLowerCase());
        break;
      case 'upper':
        setOutput(input.toUpperCase());
        break;
      case 'title':
        setOutput(
          input
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ')
        );
        break;
      case 'underline':
        setOutput(
          input
            .split(' ')
            .map((word) => word.split('').join('\u0332') + '\u0332')
            .join(' ')
        );
        break;
      case 'hyphen':
        setOutput(input.replace(/ /g, '-'));
        break;
      case 'camel':
        setOutput(
          input
            .split(' ')
            .map((word, index) =>
              index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join('')
        );
        break;
      case 'pascal':
        setOutput(
          input
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join('')
        );
        break;
      default:
        break;
    }
  };


  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Script'); // State for button label

  const handleCopy = () => {
    navigator.clipboard.writeText(output);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Script'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };


   // Clear input fields
   const clearFields = () => {
    setInput('');
    setOutput('');
  };


      // Function to calculate text statistics
      const calculateTextStats = (text) => {
        const totalCharacters = text.length;
        const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
        const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
        const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
        const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
    
        return {
          totalCharacters,
          totalCharactersWithoutSpace,
          totalWords,
          totalParagraphs,
          totalSentences,
        };
      };
    
    
        // Calculate stats dynamically based on current binary value
    const stats = calculateTextStats(input);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      
        <div className="card-body">
        
          <textarea
            className="form-control mb-3"
            rows="4"
            value={input}
            onChange={handleInput}
            placeholder="Enter text here..."
          />
          <div className="d-flex flex-wrap justify-content-center mb-3">
            {[
              { label: 'Sentence Case', type: 'sentence' },
              { label: 'Lowercase', type: 'lower' },
              { label: 'UPPERCASE', type: 'upper' },
              { label: 'Title Case', type: 'title' },
              { label: 'Underline', type: 'underline' },
              { label: 'Hyphen (-)', type: 'hyphen' },
              { label: 'CamelCase', type: 'camel' },
              { label: 'PascalCase', type: 'pascal' }
            ].map(({ label, type }) => (
              <button
                key={type}
                className="btn btn-primary m-1"
                onClick={() => handleConvert(type)}
              >
                {label}
              </button>
            ))}
          </div>
          <textarea
            className="form-control mb-3"
            rows="4"
            value={output}
            readOnly
          />
          <button className="btn btn-primary mt-3" onClick={handleCopy}>
          {copyButtonLabel}
         </button>
         <button className="btn btn-danger mt-3" onClick={clearFields}>
            Clear
          </button>
        </div>

        <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
     
    </div>
  );
};

export default TextConverter;
